import { jwtDecode } from 'jwt-decode';
import { clearDraftJobSession, clearDraftCompanySession, clearDraftFileSession } from './sessionStorage';

export const JWT_LOCAL_STORAGE = 'token';

export const logout = () => {
  // Remove isLoggedIn flag from localStorage
  localStorage.removeItem(JWT_LOCAL_STORAGE);
  
  // Clear all draft sessions to prevent cross-user data contamination
  clearDraftJobSession();
  clearDraftCompanySession();
  clearDraftFileSession();
  
  //logOut();
};

export const isNotExpired = (expiresIn) => {
  let expiresAt = expiresIn * 1000 + new Date().getTime();
  return new Date().getTime() < expiresAt;
};

export const saveJWTInfoToLocalStorage = (accessToken) => {
  // Set accessToken in localStorage
  localStorage.setItem(JWT_LOCAL_STORAGE, accessToken);
};

// TODO: Check how to implement this function for expired token. User service already has a function for this.
export const renewToken = () => {};

export const getJTWLocalStorage = () => {
  // Get accessToken in localStorage
  return localStorage.getItem(JWT_LOCAL_STORAGE);
};

const getJwtPayload = (JWT) => {
  return JWT ? jwtDecode(JWT) : null;
};

export const getLocalStorageAuthentication = () => {
  const JWT = getJTWLocalStorage();
  const isValidJwt = JWT && JWT !== 'undefined';
  const jwtPayload = isValidJwt ? getJwtPayload(JWT) : null;
  const isValidSession =
    isValidJwt &&
    jwtPayload &&
    isNotExpired(jwtPayload.exp) &&
    jwtPayload.userId;
  
  if (!isValidSession) {
    return null;
  }
  
  // Extract fullName with fallback
  const fullName = jwtPayload.fullName || jwtPayload.full_name || 'User';
  
  // Extract roles from JWT payload (critical for backend authorization)
  const roles = jwtPayload.roles || [];
  
  return { 
    token: JWT, 
    userId: jwtPayload.userId,
    email: jwtPayload.email,
    fullName: fullName,
    roles: roles  // Include roles for authorization
  };
};
